import { select, takeLatest } from 'redux-saga/effects'
import { NotificationCenterConstants } from '../store/notificationCenter.constants'
import Logger from '../../../services/logger.service'
import LocalStorageService from '../../../services/localStorage.service'
import { getUserSelector } from '../../user/selectors'
import { getNotificationCenterSelector } from '../selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

function* saveViewedNotificationIds() {
  const { userId, databaseUserName } = yield select(getUserSelector)
  const { viewedNotificationIds } = yield select(getNotificationCenterSelector)
  try {
    LocalStorageService.setItemForUserIdAndCleanDatabaseUserName(
      userId,
      databaseUserName,
      'viewedNotificationIds',
      JSON.stringify(viewedNotificationIds)
    )
  } catch (e: any) {
    Logger.warn(`Mark notifications viewed: failed to persist viewedNotificationIds - ${e?.message ?? 'unknown'}`)
  }
}

export function* saveViewedNotificationIdsSaga() {
  yield takeLatest(
    NotificationCenterConstants.MARK_NOTIFICATIONS_VIEWED,
    performWithMutexHOG,
    saveViewedNotificationIds
  )
}
